import { SizedBox } from '../../base/SizedBox/SizedBox'
import styles from './GlanceIndicatorLive.module.scss'

interface IGlanceIndicatorLive {
  icon: string
  text: string
  value: string | undefined
  smallText?: string
  smallValue?: string
  unit: string
}

export const GlanceIndicatorLive = ({ icon, text, value, smallText, smallValue, unit }: IGlanceIndicatorLive) => {
  const valueWithUnit = value && `${value} ${unit}`
  const smallValueWithUnit = smallValue != null ? `${smallValue} ${unit}` : null
  return (
    <div className={value === undefined ? styles.containerUnavailable : styles.container}>
      <img src={icon} className={styles.icon} />
      <SizedBox width={6} />
      <div className={styles.col}>
        <div className={styles.value}>{valueWithUnit}</div>
        <div className={styles.text}>{text}</div>
        {smallValueWithUnit != null && <>
          <span className={styles.smallValue}>{smallValueWithUnit}</span>
          <div className={styles.smallText}>{smallText}</div>
        </>}
      </div>
    </div>
  )
}
